export const FETCH_VIRTUAL_MACHINES_LIST_START =
  "FETCH_VIRTUAL_MACHINES_LIST_START";
export const FETCH_VIRTUAL_MACHINES_LIST_FAILURE =
  "FETCH_VIRTUAL_MACHINES_LIST_FAILURE";
export const FETCH_VIRTUAL_MACHINES_LIST_SUCCESS =
  "FETCH_VIRTUAL_MACHINES_LIST_SUCCESS";
export const CREATE_VIRTUAL_MACHINE_TASK_START =
  "CREATE_VIRTUAL_MACHINE_TASK_START";
export const CREATE_VIRTUAL_MACHINE_TASK_SUCCESS =
  "CREATE_VIRTUAL_MACHINE_TASK_SUCCESS";
export const CREATE_VIRTUAL_MACHINE_TASK_FAILURE =
  "CREATE_VIRTUAL_MACHINE_TASK_FAILURE";
export const FETCH_TASK_STATUS_LIST_START = "FETCH_TASK_STATUS_LIST_START";
export const FETCH_TASK_STATUS_LIST_SUCCESS = "FETCH_TASK_STATUS_LIST_SUCCESS";
export const FETCH_TASK_STATUS_LIST_FAILURE = "FETCH_TASK_STATUS_LIST_FAILURE";
export const CREATE_VM_TASK_ID_LIST = "CREATE_VM_TASK_ID_LIST";
export const UPDATE_TASK_STATUS = "UPDATE_TASK_STATUS";
export const CONTROL_VM_START = "CONTROL_VM_START";
export const CONTROL_VM_SUCCESS = "CONTROL_VM_SUCCESS";
export const CONTROL_VM_FAILURE = "CONTROL_VM_FAILURE";
export const DELETE_VM_START = "DELETE_VM_START";
export const DELETE_VM_SUCCESS = "DELETE_VM_SUCCESS";
export const DELETE_VM_FAILURE = "DELETE_VM_FAILURE";
export const FETCH_VIRT_RECOVERY_POINTS_START =
  "FETCH_VIRT_RECOVERY_POINTS_START";
export const FETCH_VIRT_RECOVERY_POINTS_SUCCESS =
  "FETCH_VIRT_RECOVERY_POINTS_SUCCESS";
export const FETCH_VIRT_RECOVERY_POINTS_FAILURE =
  "FETCH_VIRT_RECOVERY_POINTS_FAILURE";
export const RESET_SLIDER_CONFIGS = "RESET_SLIDER_CONFIGS";
export const UPDATE_VM_CONFIGURATIONS_START = "UPDATE_VM_CONFIGURATIONS_START";
export const UPDATE_VM_CONFIGURATIONS_SUCCESS =
  "UPDATE_VM_CONFIGURATIONS_SUCCESS";
export const UPDATE_VM_CONFIGURATIONS_FAILURE =
  "UPDATE_VM_CONFIGURATIONS_FAILURE";
export const REBUILDVM_START = "REBUILDVM_START";
export const REBUILDVM_SUCCESS = "REBUILDVM_SUCCESS";
export const REBUILDVM_FAILURE = "REBUILDVM_FAILURE";
export const VIRT_USER_INFO_START = "VIRT_USER_INFO_START";
export const VIRT_USER_INFO_SUCCESS = "VIRT_USER_INFO_SUCCESS";
export const VIRT_USER_INFO_FAILURE = "VIRT_USER_INFO_FAILURE";
export const CLOSE_SSE_CONNECTION = "CLOSE_SSE_CONNECTION";
export const SET_RPC_MACHINE_STATUS_VI = "SET_RPC_MACHINE_STATUS_VI";
export const SET_RPC_SOCKET_DETAILS_VI = "SET_RPC_SOCKET_DETAILS_VI";
export const LOGOUT_VIRT_INSTANCES = "LOGOUT_VIRT_INSTANCES";
export const LOGOUT_SINGLE_VIRT_INSTANCES = "LOGOUT_SINGLE_VIRT_INSTANCES";
export const RPC_CONSOLE_ACCESS_IN_PROGRESS = "RPC_CONSOLE_ACCESS_IN_PROGRESS";
export const RPC_CONSOLE_BOOT_PROGRESS = "RPC_CONSOLE_BOOT_PROGRESS";
export const REMOVE_RPC_CONSOLE_BOOT_PROGRESS =
  "REMOVE_RPC_CONSOLE_BOOT_PROGRESS";
